import HttpRequest from "./HttpRequest";
import Helpers from "@/utils/Helpers";

class SiteApiProvider extends HttpRequest {
  constructor() {
    super();
  }

  async requestGetSiteList(filters) {
    let query_string = Helpers.generateQueryString(filters);
    const request_url = "/care/sites" + query_string;
    const data = await this.get(request_url);
    return data;
  }
}

export default SiteApiProvider;
